import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";

export const ItemName = ({ name }: { name: string }) => {
  return <FixaText textStyle="Heading.XS">{name}</FixaText>;
};
